import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import AcademicTermService from "../../src/Services/AcademicTerm.service";
const AcademicTermLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return AcademicTermService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return AcademicTermService.searchAll(search);
        },
        optionRenderer: function optionRenderer(academicTerm) {
            return _jsx("span", { children: academicTerm.name });
        },
    });
};
export default AcademicTermLookup;
